import { version } from '../../../package.json';
import { applyAutofocus } from './helpers/autofocus';
import { observeScrollbarWidth } from './helpers/scrollbar-width';
import * as utils from './helpers/utils';

export default function () {
  window.stzhComponents = {
    defaultLocale: 'de',
    pathMedia: '/',
    pathTranslations: '/',
    cacheTranslations: true,
    formats: {},
    translations: null,
    fixAutofocus: true,
    fixHashfocus: true,
    ...window.stzhComponents || {},
    version,
    supportedLocales: ['de', 'en'],
    utils
  };

  if (window.stzhComponents.translations === null) {
    window.stzhComponents.translationsLoading = utils.fetchTranslations(document.documentElement).then((translations) => {
      window.stzhComponents.translations = translations;
    }).catch((reason) => {
      console.error("Translations couldn't load:", reason)
    });
  }

  applyAutofocus();
  observeScrollbarWidth();
}
